var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraLook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1712,
    height: 1712,
    viewBox: "0 0 1712 1712",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_707_763)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 144,
    width: 1322.58,
    height: 1322.58,
    rx: 660.504,
    transform: "rotate(1.07152 207 144)",
    fill: "#F93564"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M855.144 780.275C832.189 780.275 810.648 788.849 794.05 804.967C777.805 820.743 768.977 841.663 769.33 863.269V863.612C769.33 885.904 778.158 906.824 794.403 922.6C810.648 938.376 832.189 946.95 855.144 946.95C902.465 946.95 940.604 909.568 940.957 863.612C940.957 841.32 932.129 820.4 915.884 804.624C899.64 788.849 878.098 780.275 855.144 780.275M1053.25 782.677C1035.6 782.677 1021.47 768.959 1021.47 751.811C1021.47 734.663 1035.6 720.602 1053.25 720.602C1070.91 720.602 1085.39 734.663 1085.39 751.811C1085.39 768.959 1070.91 782.677 1053.25 782.677M952.962 958.954C927.889 983.304 893.281 998.394 855.142 998.394C818.062 998.394 783.454 984.333 756.968 958.954C730.836 933.233 716.357 899.623 716.357 863.614C716.004 827.946 730.482 794.337 756.615 768.616C783.101 742.894 818.062 728.833 855.142 728.833C892.222 728.833 927.183 742.894 953.316 768.273C979.448 793.994 993.927 827.946 993.927 863.614C993.574 900.995 978.036 934.605 952.962 958.954M1054.32 624.232C1051.14 624.232 1048.67 622.517 1047.25 620.117L1043.72 612.572C1034.19 593.023 1023.24 570.388 1016.53 557.356C1000.28 526.491 972.386 509.343 938.131 509H771.801C737.546 509.343 710.001 526.491 693.757 557.356C686.694 571.074 674.687 595.767 664.799 616.001L662.68 620.117C661.621 622.86 658.795 624.232 655.97 624.232C570.863 624.232 502 691.451 502 773.759V977.473C502 1059.78 570.863 1127 655.97 1127H1054.32C1139.07 1127 1208.29 1059.78 1208.29 977.473V773.759C1208.29 691.451 1139.07 624.232 1054.32 624.232",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_707_763",
    x: -11.9989,
    y: -11.4127,
    width: 1735.62,
    height: 1735.62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 38.8532
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 97.133
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_707_763"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_707_763",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraLook);
export default __webpack_public_path__ + "static/media/Camera-look.2a62c6f0159717114f158a7b5b3d07a2.svg";
export { ForwardRef as ReactComponent };